export default __webpack_public_path__ + "static/media/070-tuvalu-1.ba3e9c0c.svg";